import { render, staticRenderFns } from "./DemoView.vue?vue&type=template&id=36543e9f&scoped=true&"
import script from "./DemoView.vue?vue&type=script&lang=js&"
export * from "./DemoView.vue?vue&type=script&lang=js&"
import style0 from "./DemoView.vue?vue&type=style&index=0&id=36543e9f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36543e9f",
  null
  
)

export default component.exports